import { render, staticRenderFns } from "./_suppliers.vue?vue&type=template&id=22ab9400&scoped=true&"
import script from "./_suppliers.vue?vue&type=script&lang=js&"
export * from "./_suppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ab9400",
  null
  
)

export default component.exports